import { Stack, Tooltip, Typography } from '@mui/material';

import React from 'react';

import { ReactComponent as DocumentIcon } from 'common/assets/images/chatdocument.svg';
import { ReactComponent as DeleteIcon } from 'common/assets/images/delete-icon.svg';
import { truncateString } from 'common/utils/utilFunctions';

import { IUploadedDocumnetInfo } from '../api/type-def';

import styles from './UploadDocumentDeleteCard.module.scss';

interface IUploadDocumentDeleteCard {
	key?: string;
	fileInfo: IUploadedDocumnetInfo;
	onDeleteActionHandler: (data: IUploadedDocumnetInfo) => void;
}
const UploadDocumentDeleteCard = (props: IUploadDocumentDeleteCard) => {
	const { fileInfo, onDeleteActionHandler } = props;
	const { iconFillColor } = styles;

	const onDeleteHandler = (data: IUploadedDocumnetInfo) => {
		onDeleteActionHandler(data);
	};
	return (
		<Stack
			direction="row"
			spacing={1}
			className={styles['upload-document-delete-card-container']}
		>
			<DocumentIcon />

			<Tooltip
				title={fileInfo?.name}
				arrow
				placement="top"
				componentsProps={{
					popper: {
						sx: { zIndex: '10001 !important' },
					},
				}}
			>
				<Typography
					className={styles['upload-document-delete-card']}
					data-testid="upload-doc-cardlistname"
				>
					{`${truncateString(fileInfo?.name, 12)}...`}
				</Typography>
			</Tooltip>
			<DeleteIcon
				fill={iconFillColor}
				data-testid="delete-btn"
				onClick={() => onDeleteHandler(fileInfo)}
			/>
		</Stack>
	);
};

export default UploadDocumentDeleteCard;
